'use strict';

module.exports = {
	init: function () {
		(function ($) {
			$('#excludeFromDirectory').on('change', togglePermissions);
			$('#nobiz').on('change', togglePermissions);

			togglePermissions();
		})(jQuery);
	}
};

function togglePermissions() {
	(function ($) {
		if ($('#excludeFromDirectory').is(':checked')) {
			$('.disable-on-exclude').removeAttr('checked');
			$('.disable-on-exclude').attr('disabled', true);
		} else {
			$('.disable-on-exclude').removeAttr('disabled');
		}
		if ($('#nobiz').is(':checked')) {
			$('.disable-on-nobiz').removeAttr('disabled');
		} else {
			$('.disable-on-nobiz').removeAttr('checked');
			$('.disable-on-nobiz').attr('disabled', true);
		}
	})(jQuery);
}
